module.exports = __webpack_public_path__ + "img/deux-battants.edd381b.svg";